import gql from 'graphql-tag';

export const getMyMockExamList = gql`
  query myMockExamList {
    myMockExamList {
      id
      examRounds {
        id
        title
        examCards {
          id
          examId
          exam {
            id
            status
          }
          subjectCode
        }
      }
    }
  }
`;

export const getMyMockExamResults = gql`
  query myMockExamResults($examCardIds: [ID]!) {
    myMockExamResults(examCardIds: $examCardIds) {
      id
      examId
      score
    }
  }
`;
